import styled from 'styled-components';

import { StepContentWrapper } from 'components';

export const ContractWrapper = styled(StepContentWrapper)((props) => ({}));

export const ButtonsHolder = styled.div(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  padding: '16px 24px',
}));

export const PaymentContent = styled.div(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}));

export const PaymentContentForm = styled.div((props) => ({
  display: 'grid',
  justifyItems: 'center',
  [`@media${props.theme.devices.laptop}`]: {
    flexDirection: 'column',
  },
}));

